import { createFileRoute } from "@tanstack/react-router";
import { MilestoneDetail } from "@/components/planning/milestones/MilestoneDetail";

export const Route = createFileRoute("/_app/p/$productKey/milestones/$milestoneId")({ component: View });

function View() {
  const { productKey, milestoneId } = Route.useParams();
  const search = Route.useSearch();
  return <MilestoneDetail productKey={productKey} milestoneId={milestoneId} search={search} />;
}
